import {LOCALE} from "modules/constants";
import cflLogo from "assets/images/team-quiz-logo.png";
import cflLogoFr from "assets/images/team-quiz-fr-logo.png";
import cflGzMobileLogo from "assets/images/cfl-gz-mb-logo.png";
import cflGzFrMobileLogo from "assets/images/cfl-gz-fr-mobile-logo.png";
import cflGzLogo from "assets/images/cfl-gz-logo.png";
import cflGzFrLogo from "assets/images/cfl-gz-fr-logo.png";

export const getLogo = () => (LOCALE === "en" ? cflLogo : cflLogoFr);

export const getGZLogo = (isMobile?: boolean) => {
	if (isMobile) {
		return LOCALE === "en" ? cflGzMobileLogo : cflGzFrMobileLogo;
	}

	return LOCALE === "en" ? cflGzLogo : cflGzFrLogo;
};
